import Div from "@jumbo/shared/Div";
import {
    Alert,
    Avatar,
    Box,
    Button,
    ButtonGroup,
    Chip,
    FormControl,
    InputLabel,
    ListItemAvatar,
    MenuItem,
    Snackbar,
    Tab,
    Tabs,
    TextField,
} from "@mui/material";
import Select from "@mui/material/Select";
import DDImage from "../../../../component/DDImage";
import Stack from "@mui/material/Stack";
import moment from "moment/moment";
import React, { useState } from "react";
import { useAppMutation } from "../../../../services";
import parentServices from "../../../../services/parent-services";
import { isPastDate } from "../../../../utils/constants/appActions";
import { useBookingContext } from "../context";
import { useTranslation } from "react-i18next";
import LoadingButton from "@mui/lab/LoadingButton";
import AddBookingByTeacher from "./add-booking-by-teacher";
import AddBookingByDate from "./add-booking-by-date";
import CreditsCarousel from "./CreditsCarousel";

import PersonOutlineRoundedIcon from "@mui/icons-material/PersonOutlineRounded";
import { Typography, OutlinedInput, InputAdornment } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

import { IconButton, Divider } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Skeleton from "@mui/material/Skeleton";



const AddBooking = ({}) => {
    const { availableDates, setAvailableDates } = useBookingContext();
    const [showWarning, setShowWarning] = useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [type] = React.useState("courses");
    const [showConfirmation, setShowConfirmation] = useState(false);
    const { t } = useTranslation();
    const [pastDate, setPastDate] = useState(false);
    const [isEditable] = useState(true);
    const { globalState, setGlobalState } = useBookingContext();
    const [children, setChildren] = React.useState([]);
    const [open, setOpen] = React.useState(false);
    const [minDate, setMinDate] = useState();
    const [maxDate, setMaxDate] = useState();
    const [sTimings, setSTimings] = useState([]);
    const [subscription, setSubscription] = React.useState({});
    const [recommendedSubscription, setRecommendedSubscription] = React.useState(
        {},
    );
    const [subscriptions, setSubscriptions] = React.useState([]);
    const [cancellationConfirmed, setCancellationConfirmed] = useState(false);
    const [error, setError] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const [teachers, setTeachers] = useState([]);
    const [values, setValues] = React.useState({
        startDate: "",
        startTime: "",
        title: "Student Booking",
        description: "",
        subscriptionId: "",
        teacherId: "",
        childId: "",
        studentid: "",
        meetingLink: "",
    });

    const {
        mutate: loadActiveSubscriptions,
        isSuccess: isLASSuccess,
        data: lasData,
        isLoading: isLASLoading,
    } = useAppMutation(parentServices.loadActiveSubscriptions);

    const {
        mutate: loadChildren,
        isSuccess: isCSuccess,
        data: cResult,
    } = useAppMutation(parentServices.loadEvaluatedChildren);

    const {
        mutate: saveBooking,
        isSuccess: isBSuccess,
        data: bResult,
        isLoading: isBLoading,
        isError: isBError,
    } = useAppMutation(parentServices.saveBooking);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    React.useEffect(() => {
        if (globalState.booking) {
            const booking = { ...values, ...globalState.booking };
            setValues(booking);
            const min = globalState.minDate;
            const max = globalState.maxDate;
            setPastDate(isPastDate(booking.sstartDate));
            setMinDate(min);
            setMaxDate(max);
            loadChildren({});
            loadActiveSubscriptions({
                studentId: booking.studentId,
                subscriptionId: values.subscriptionId,
                date: booking.sstartDate,
            });
        }
    }, [globalState]);

    React.useEffect(() => {
        if (isBSuccess) {
            setGlobalState({
                ...globalState,
                booking: undefined,
                addEditBooking: false,
                refreshList: true,
            });
        } else if (isBError) {
            setErrMsg(t("errMsg.saving"));
        }
    }, [isBError, isBSuccess]);

    React.useEffect(() => {
        if (isCSuccess && cResult) {
            const c = [...cResult];
            setChildren(c);
            // setValues({...values, childId : values.childId});
        }
    }, [isCSuccess, cResult]);

    React.useEffect(() => {
        if (isLASSuccess) {
            console.log("loadActiveSubscriptions SUCCESS");
            console.log("Response data:", lasData);
        }
    }, [isLASSuccess, lasData]);


    React.useEffect(() => {
        console.log("isLASSuccess", isLASSuccess, lasData);
        if (isLASSuccess && lasData) {
            const { subscription: sub, subscriptions } = lasData;

            console.log("Subscriptions.......", subscription, subscriptions);
            setSubscriptions([...subscriptions]);
            setRecommendedSubscription({ ...sub });

            const d = new Date(minDate);
            let sD = new Date(subscription.expiredDate);
            if (!values.subscriptionId) {
                setValues({
                    ...values,
                    subscriptionId: subscription?.subscriptionId,
                });
                setSubscription({ ...sub });
                sD = new Date(sub?.expiredDate);
            }
            d.setMonth(d.getMonth() + 3);

            if (d > sD) {
                setMaxDate(sD);
            } else {
                setMaxDate(d);
            }
        }
    }, [isLASSuccess]);

    const renderSubscriptionAlert = () => {
        if (!subscriptions || subscriptions?.length == 0) {
            return (
                <Stack sx={{ width: "100%" }} spacing={2}>
                    <Alert severity="warning" onClose={() => {}}>
                        {t("calendar.subscribe")}
                    </Alert>
                </Stack>
            );
        }

        return null;
    };

    const handleChange = (prop) => (event) => {
        setValues({ ...values, [prop]: event.target.value });
        if (prop === "childId") {
            loadActiveSubscriptions({
                studentId: event.target.value,
                subscriptionId: values.subscriptionId,
                date: values.sstartDate,
            });
        } else if (prop === "subscriptionId") {
            const subscriptionId = event.target.value;
            const sub = subscriptions.find(
                (ii) => ii.subscriptionId === subscriptionId,
            );
            setSubscription(sub);
            const d = new Date(minDate);
            const sD = new Date(sub.expiredDate);
            d.setMonth(d.getMonth() + 3);
            if (d > sD) {
                setMaxDate(sD);
            } else {
                setMaxDate(d);
            }
        }
    };

    const isDisableSave = () => {
        if (!subscriptions || subscriptions?.length == 0) {
            return true;
        }

        return false;
    };

    const handleSaveBooking = () => {
        if (values.startTime && values.startDate && values.childId) {
            const selectedStartDateTime = new Date(
                `${values.startDate}T${values.startTime}`,
            );
            const currentTime = new Date();
            const timeDifference =
                selectedStartDateTime.getTime() - currentTime.getTime();
            const hoursDifference = Math.floor(timeDifference / (1000 * 60 * 60)); // Convert milliseconds to hours

            if (hoursDifference < 24) {
                setShowWarning(true);
                return; // Exit the function to show the warning message
            }
            const selectedEndDateTime = new Date(
                `${values.startDate}T${values.startTime}`,
            );
            selectedEndDateTime.setMinutes(selectedEndDateTime.getMinutes() + 30);

            const booking = {
                description: values.description,
                startDate: selectedStartDateTime,
                endDate: selectedEndDateTime,
                studentId: values.childId,
                bookingId: values.bookingId,
                teacherId: values.teacherId,
                subscriptionId: values.subscriptionId,
            };

            saveBooking(booking);
        } else {
            setErrMsg(t("common.inputError"));
            setTimeout(() => {
                setErrMsg("");
            }, 5000);
        }
    };



    const creditsTrackRef = React.useRef(null);

    const scrollCreditsByCard = (dir) => {
        const el = creditsTrackRef.current;
        if (!el) return;

        const card = el.querySelector("[data-credit-card='true']");
        const step = card ? card.offsetWidth + 14 : 240;
        el.scrollBy({ left: dir * step, behavior: "smooth" });
    };

// ✅ same logic as dropdown's handleChange("subscriptionId")
    const selectSubscriptionCard = (subscriptionId) => {
        if (pastDate || !isEditable || !values?.childId) return;

        const sub = subscriptions?.find((s) => s.subscriptionId === subscriptionId);
        if (!sub) return;

        setValues((prev) => ({ ...prev, subscriptionId }));
        setSubscription(sub);

        // keep your maxDate logic
        const d = new Date(minDate);
        const sD = new Date(sub.expiredDate);
        d.setMonth(d.getMonth() + 3);
        setMaxDate(d > sD ? sD : d);
    };



    return (
        <FormControl
            noValidate
            autoComplete="off"
            sx={{
                width: { xl: 500, sm: 400, md: 450, xs: "100%" },
                padding: "0",
                margin: "2",
            }}
        >
            <Box sx={{ marginLeft: -1, marginRight: -1 }}>
                {renderSubscriptionAlert()}

                {showWarning && (
                    <Snackbar
                        open={showWarning}
                        autoHideDuration={6000}
                        onClose={() => setShowWarning(false)}
                        anchorOrigin={{ vertical: "top", horizontal: "center" }}
                        sx={{ width: "100%", marginTop: 2 }}
                        spacing={2}
                    >
                        <Alert onClose={() => setShowWarning(false)} severity="warning">
                            {t("calendar.notChange")}
                        </Alert>
                    </Snackbar>
                )}
                {/*<Tabs
          value={activeTab}
          onChange={handleTabChange}
          aria-label="booking tabs"
          variant="fullWidth"
          sx={{ marginBottom: 2 }}
        >
          <Tab sx={{ px: "20%" }} label={t("parent.title.byTeacher")} />
          <Tab sx={{ px: "20%" }} label={t("parent.title.byDate")} />
        </Tabs>*/}

                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    variant="fullWidth"
                    sx={{
                        backgroundColor: "#f2f2f2",
                        borderBottom: "1px solid #e0e0e0",
                        minHeight: 52,
                        "& .MuiTabs-indicator": {
                            height: 3,
                            backgroundColor: "#2d6bbf",
                        },
                    }}
                >
                    <Tab
                        disableRipple
                        label={t("parent.title.byTeacher")}
                        sx={{
                            minHeight: 52,
                            fontWeight: 700,
                            fontSize: 14,
                            letterSpacing: "0.05em",
                            color: "#9aa0a6",
                            backgroundColor: "#f2f2f2",
                            borderRight: "1px solid #e0e0e0",
                            "&.Mui-selected": {
                                backgroundColor: "#ffffff",
                                color: "#1D6ADE",
                            },
                            fontFamily: "'Nunito', sans-serif",
                        }}
                    />

                    <Tab
                        disableRipple
                        label={t("parent.title.byDate")}
                        sx={{
                            minHeight: 52,
                            fontWeight: 700,
                            fontSize: 14,
                            letterSpacing: "0.05em",
                            color: "#9aa0a6",
                            backgroundColor: "#f2f2f2",
                            "&.Mui-selected": {
                                backgroundColor: "#ffffff",
                                color: "#1D6ADE",
                            },
                            fontFamily: "'Nunito', sans-serif",
                        }}
                    />
                </Tabs>

                {/*<Box sx={{ mt: 2 }}>
              <CreditsCarousel />
          </Box>*/}







                {/* ✅ CHILD (UI like screenshot) */}
                <Box sx={{ mt: 3 }}>
                    {/* top label row */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.6 }}>
                        <Box
                            component="span"
                            sx={{
                                fontSize: 20,
                                lineHeight: 1,
                                flexShrink: 0,
                                display: "inline-flex",
                                alignItems: "center",
                            }}
                        >
                            👤
                        </Box>

                        <Typography
                            sx={{
                                fontSize: "13px",
                                fontWeight: 700,
                                fontFamily: "'Nunito', sans-serif",
                                letterSpacing: "0.5px",
                                color: "#002465",
                                textTransform: "uppercase",
                                lineHeight: 1,
                            }}
                        >
                            {t("parent.title.child")}
                        </Typography>
                    </Box>

                    <FormControl fullWidth>
                        <Select
                            disabled={pastDate || !isEditable}
                            value={values.childId}
                            onChange={handleChange("childId")}
                            displayEmpty
                            input={<OutlinedInput sx={{ borderRadius: 2 }} />}
                            renderValue={(selected) => {
                                const selectedChild = children?.find((c) => c.studentId === selected);

                                if (!selectedChild) {
                                    return (
                                        <Typography sx={{ color: "#9aa0a6" }}>
                                            {t("parent.title.child")}
                                        </Typography>
                                    );
                                }

                                const imgPath = selectedChild?.images?.[0];

                                return (
                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                        {imgPath ? (
                                            <Box
                                                sx={{
                                                    width: 28,
                                                    height: 28,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <DDImage
                                                    path={imgPath}
                                                    alt={`${selectedChild.firstName} ${selectedChild.lastName}`}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                            </Box>
                                        ) : (
                                            <Avatar sx={{ width: 28, height: 28, flexShrink: 0 }}>
                                                {selectedChild?.firstName?.[0] || "C"}
                                            </Avatar>
                                        )}

                                        <Typography sx={{ fontWeight: 600, color: "#111827" }}>
                                            {selectedChild.firstName} {selectedChild.lastName}
                                        </Typography>
                                    </Box>
                                );
                            }}
                            sx={{
                                bgcolor: "#fff",
                                borderRadius: 2,

                                // ✅ remove extra left spacing + keep nice height
                                "& .MuiSelect-select": {
                                    display: "flex",
                                    alignItems: "center",
                                    minHeight: 48,   // ⬅️ reduced height
                                    py: 0.8,         // ⬅️ less vertical padding
                                    pl: 1.1,
                                    pr: 4,
                                },


                                // ✅ outlined border
                                "& .MuiOutlinedInput-notchedOutline": { borderColor: "#d0d5dd" },
                                "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: "#b8c0cc" },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#2d6bbf",
                                    borderWidth: 1,
                                },
                            }}
                            MenuProps={{
                                PaperProps: { sx: { mt: 1, borderRadius: 2, overflow: "hidden" } },
                            }}
                        >
                            {children?.map((item) => {
                                const imgPath = item?.images?.[0];

                                return (
                                    <MenuItem
                                        key={item.studentId}
                                        value={item.studentId}
                                        sx={{ py: 1.2, display: "flex", alignItems: "center", gap: 1 }}
                                    >
                                        {imgPath ? (
                                            <Box
                                                sx={{
                                                    width: 30,
                                                    height: 30,
                                                    borderRadius: "50%",
                                                    overflow: "hidden",
                                                    flexShrink: 0,
                                                }}
                                            >
                                                <DDImage
                                                    path={imgPath}
                                                    alt={`${item.firstName} ${item.lastName}`}
                                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                                />
                                            </Box>
                                        ) : (
                                            <Avatar sx={{ width: 30, height: 30, flexShrink: 0 }}>
                                                {item?.firstName?.[0] || "C"}
                                            </Avatar>
                                        )}

                                        <Typography sx={{ fontWeight: 600 }}>
                                            {item.firstName} {item.lastName}
                                        </Typography>
                                    </MenuItem>
                                );
                            })}
                        </Select>

                    </FormControl>
                </Box>

                {/*(isLASLoading || (subscriptions && subscriptions.length > 0)) && (
                    <Box sx={{ position: "relative", mt: 2 }}>
                        <Typography
                            sx={{
                                display: "block",
                                fontWeight: 800,
                                fontSize: 13,
                                color: "#002465",
                                mb: "15px",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                fontFamily: "'Nunito', sans-serif",
                            }}
                        >
                            {t("common.chooseCredits")}
                        </Typography>




                        <IconButton
                            onClick={() => scrollCreditsByCard(-1)}
                            disabled={!values?.childId || pastDate || !isEditable || isLASLoading}
                            sx={{
                                position: "absolute",
                                left: -12,
                                top: "55%",
                                transform: "translateY(-55%)",
                                zIndex: 2,
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                border: "2px solid #2d6bbf",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                "&:hover": { backgroundColor: "#f6faff" },
                                "&.Mui-disabled": { opacity: 0.35 },
                            }}
                        >
                            <ChevronLeftIcon sx={{ color: "#2d6bbf" }} />
                        </IconButton>


                        <IconButton
                            onClick={() => scrollCreditsByCard(1)}
                            disabled={!values?.childId || pastDate || !isEditable || isLASLoading}
                            sx={{
                                position: "absolute",
                                right: -12,
                                top: "55%",
                                transform: "translateY(-55%)",
                                zIndex: 2,
                                width: 40,
                                height: 40,
                                borderRadius: "50%",
                                border: "2px solid #2d6bbf",
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
                                "&:hover": { backgroundColor: "#f6faff" },
                                "&.Mui-disabled": { opacity: 0.35 },
                            }}
                        >
                            <ChevronRightIcon sx={{ color: "#2d6bbf" }} />
                        </IconButton>


                        <Box
                            ref={creditsTrackRef}
                            sx={{
                                overflowX: "auto",
                                display: "flex",
                                gap: 1.5,
                                px: 1.2,
                                py: 1,
                                scrollSnapType: "x mandatory",
                                "&::-webkit-scrollbar": { display: "none" },
                            }}
                        >

                            {isLASLoading &&
                                Array.from({ length: 3 }).map((_, idx) => (
                                    <Box
                                        key={`sk-${idx}`}
                                        data-credit-card="true"
                                        sx={{
                                            minWidth: 210,
                                            height: 150,
                                            borderRadius: 2,
                                            border: "3px solid #dedede",
                                            backgroundColor: "#fff",
                                            px: 1.4,
                                            pt: 1.1,
                                            pb: 0.6,
                                            scrollSnapAlign: "start",
                                        }}
                                    >
                                        <Skeleton variant="text" height={22} sx={{ mb: 1 }} />
                                        <Skeleton variant="text" height={40} sx={{ mb: 1 }} />
                                        <Skeleton variant="text" height={18} sx={{ mb: 1 }} />
                                        <Skeleton variant="text" height={16} />
                                    </Box>
                                ))}


                            {!isLASLoading &&
                                (subscriptions || []).map((sub) => {
                                    const selected = sub.subscriptionId === values.subscriptionId;
                                    const isRecommended =
                                        sub.subscriptionId === recommendedSubscription?.subscriptionId;

                                    const used = sub.noOfUsedBooking ?? 0;
                                    const total = sub.noOfBooking ?? 0;

                                    return (
                                        <Box
                                            key={sub.subscriptionId}
                                            data-credit-card="true"
                                            onClick={() => selectSubscriptionCard(sub.subscriptionId)}
                                            sx={{
                                                minWidth: 210,
                                                height: 150,
                                                borderRadius: 2,
                                                border: selected ? "3px solid #2d6bbf" : "3px solid #dedede",
                                                backgroundColor: selected ? "#eaf4ff" : "#fff",
                                                px: 1.4,
                                                pt: 1.1,
                                                pb: 0.6,
                                                cursor:
                                                    !values?.childId || pastDate || !isEditable
                                                        ? "not-allowed"
                                                        : "pointer",
                                                opacity: !values?.childId || pastDate || !isEditable ? 0.6 : 1,
                                                scrollSnapAlign: "start",
                                                display: "flex",
                                                flexDirection: "column",
                                                position: "relative",
                                            }}
                                        >


                                            <Typography
                                                sx={{
                                                    fontWeight: 800,
                                                    fontSize: 14,
                                                    textAlign: "center",
                                                    mb: 0.6,
                                                    lineHeight: 1.2,
                                                    minHeight: "2.4em",
                                                    display: "-webkit-box",
                                                    WebkitLineClamp: 2,
                                                    WebkitBoxOrient: "vertical",
                                                    overflow: "hidden",
                                                    pr:  0, // avoid overlap with chip
                                                }}
                                            >
                                                {sub?.plan?.name}
                                            </Typography>

                                            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "baseline" }}>
                                                <Typography sx={{ fontWeight: 900, fontSize: 32, color: "#2d6bbf", lineHeight: 1 }}>
                                                    {used}
                                                </Typography>
                                                <Typography sx={{ fontSize: 13, color: "#6b7280", ml: 0.25 }}>
                                                    /{total}
                                                </Typography>
                                            </Box>

                                            <Typography sx={{ textAlign: "center", color: "#6b7280", mb: 0.7, fontSize: 13 }}>
                                                lessons
                                            </Typography>

                                            <Box sx={{ mt: "auto" }}>
                                                <Divider sx={{ my: 0.8 }} />
                                                <Typography
                                                    sx={{
                                                        textAlign: "center",
                                                        color: "#9aa0a6",
                                                        mt: 0.4,
                                                        mb: 0,
                                                        fontSize: 12,
                                                        lineHeight: 1.2,
                                                    }}
                                                >
                                                    Expires on {moment(sub.expiredDate).format("YYYY-MM-DD")}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    );
                                })}


                            {!isLASLoading && (!subscriptions || subscriptions.length === 0) && (
                                <Box sx={{ px: 1.2, py: 1 }}>
                                    <Typography sx={{ fontSize: 13, color: "#98a2b3" }}>
                                        {t("calendar.subscribe")}
                                    </Typography>
                                </Box>
                            )}
                        </Box>
                    </Box>
                )*/}





                {/*<FormControl fullWidth sx={{ mt: 1 }}>
          <InputLabel id="demo-multiple-checkbox-label">
            {t("parent.title.child")}
          </InputLabel>
          <Select
            disabled={pastDate || !isEditable}
            value={values.childId}
            label={t("parent.title.child1")}
            onChange={handleChange("childId")}
            renderValue={(selected) => {
              // Find the selected child based on the childId
              const selectedChild = children?.find(
                (child) => child.studentId === selected,
              );

              console.log("selected----------------------", selected);
              // Display only the selected child's name
              return (
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <ListItemAvatar>
                    {selectedChild && selectedChild.images?.length > 0 ? (
                      <DDImage
                        path={selectedChild.images[0]}
                        alt={
                          selectedChild.firstName + " " + selectedChild.lastName
                        }
                      />
                    ) : (
                      <Avatar
                        alt={
                          selectedChild?.firstName +
                          " " +
                          selectedChild?.lastName
                        }
                      />
                    )}
                  </ListItemAvatar>
                  {selectedChild?.firstName} {selectedChild?.lastName}
                </Box>
              );
            }}
          >
            {children &&
              children.map((item) => (
                <MenuItem key={item.studentId} value={item.studentId}>
                  <ListItemAvatar>
                    {item.images?.length > 0 ? (
                      <DDImage
                        path={item.images[0]}
                        alt={item.firstName + " " + item.lastName}
                      />
                    ) : (
                      <Avatar alt={item.firstName + " " + item.lastName} />
                    )}
                  </ListItemAvatar>
                  {item.firstName} {item.lastName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>*/}




                <FormControl fullWidth sx={{ mt: 2.5 }}>
                    <InputLabel id="demo-multiple-checkbox-label">
                        {t("calendar.subscription")}
                    </InputLabel>
                    <Select
                        disabled={pastDate || !isEditable || !values?.childId}
                        value={values.subscriptionId}
                        label={t("calendar.subscription")}
                        onChange={handleChange("subscriptionId")}
                        renderValue={(selected) => {
                            // Find the selected child based on the studentId
                            const selectedChild = subscriptions?.find(
                                (child) => child.subscriptionId === selected,
                            );

                            // Display only the selected child's name
                            return (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    {selectedChild?.plan?.name}
                                </Box>
                            );
                        }}
                    >
                        {subscriptions.map((item) => (
                            <MenuItem key={item.subscriptionId} value={item.subscriptionId}>
                                <div>
                                    {item.plan.name}
                                    <br />
                                    {t("common.expired")}{" "}
                                    {moment(item.expiredDate).format("YYYY-MM-DD")}
                                    <br />
                                    {t("common.bookingUtilize")} {item.noOfUsedBooking}/
                                    {item.noOfBooking}
                                </div>
                                {item.subscriptionId ===
                                    recommendedSubscription?.subscriptionId && (
                                        <div>
                                            <Chip
                                                label={t("common.recommended")}
                                                color={"success"}
                                                size={"small"}
                                            />
                                        </div>
                                    )}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {activeTab === 0 && (
                    <AddBookingByTeacher
                        setMaxDate={setMaxDate}
                        loadActiveSubscriptions={loadActiveSubscriptions}
                        subscription={subscription}
                        availableDates={availableDates}
                        minDate={minDate}
                        maxDate={maxDate}
                        type={type}
                        values={values}
                        setValues={setValues}
                        pastDate={pastDate}
                    />
                )}
                {activeTab === 1 && (
                    <AddBookingByDate
                        setMaxDate={setMaxDate}
                        loadActiveSubscriptions={loadActiveSubscriptions}
                        subscription={subscription}
                        availableDates={availableDates}
                        minDate={minDate}
                        maxDate={maxDate}
                        type={type}
                        values={values}
                        setValues={setValues}
                        pastDate={pastDate}
                    />
                )}

                {/*<FormControl fullWidth sx={{mt:2}}>
                <TextField
                    style={{width: '100%'}}
                    disabled={pastDate || !isEditable}
                    id="outlined-multiline-static"
                    label={t("common.desc")}
                    multiline
                    rows={2}
                    value={values.description}
                    name="description"
                    onChange={handleChange('description')}
                />

            </FormControl>*/}
                {

                    <Box
                        sx={{
                            width: "100%",
                            mt: 2,
                            px: 2,
                            py: 1.2,
                            borderRadius: 2,
                            bgcolor: "#f5f6f7",          // light green background (container)
                            border: "1px solid #e6e8ec", // soft green border
                            display: "flex",
                            alignItems: "center",
                            gap: 1.2,
                        }}
                    >
                        {/* ✅ Icon container */}
                        <Box
                            sx={{
                                width: 20,
                                height: 20,
                                borderRadius: 1,
                                bgcolor: "#12b76a", // solid green
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                            }}
                        >
                            <CheckRoundedIcon
                                sx={{
                                    fontSize: 16,
                                    color: "#ffffff",
                                }}
                            />
                        </Box>

                        {/* ✅ Text */}
                        <Typography sx={{ fontSize: 13, color: "#666",fontFamily: "'Nunito', sans-serif", }}>
                            <Box component="span" sx={{ fontWeight: 700, color: "#002465" }}>
                                {t("parent.title.reminder-title")}:
                            </Box>{" "}
                            {t("parent.title.txt")}
                        </Typography>
                    </Box>


                }
                <Stack
                    sx={{
                        mb: 2,
                        // width: '90%',
                        mx: "auto",
                        display: "block",
                        position: "relative",
                        width: { xs: "100%", xl: "100%", sm: "100%", md: "100%" },
                    }}
                    spacing={2}
                >
                    {errMsg && <Alert severity="error">{errMsg}</Alert>}
                </Stack>

                <Divider
                    sx={{
                        mt: 2,
                        mb: 2,
                        borderColor: "#e6e8ec",
                    }}
                />

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between", // push to corners
                        alignItems: "center",
                        mb: 2,
                    }}
                >
                    <Button
                        type="submit"
                        size="medium"
                        variant="contained"
                        sx={{
                            padding: "8px 20px",
                            borderRadius: "8px",
                            border: "none",
                            fontWeight: 600,
                            fontSize: "14px",
                            cursor: "pointer",
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "uppercase",
                            backgroundColor: "#E0E0E0",
                            color: "#1D6ADE",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#D0D0D0",
                            },

                        }}
                        onClick={() => {
                            setGlobalState({
                                ...globalState,
                                booking: undefined,
                                addEditBooking: false,
                            });
                        }}
                    >
                        {t("common.closeBtn")}
                    </Button>

                    <LoadingButton
                        type="submit"
                        variant="contained"
                        size="medium"
                        color="warning"
                        disabled={isDisableSave()}
                        onClick={handleSaveBooking}
                        loading={isBLoading}
                        sx={{
                            padding: "8px 20px",
                            borderRadius: "8px",
                            border: "none",
                            fontWeight: 600,
                            fontSize: "14px",
                            cursor: "pointer",
                            fontFamily: "'Nunito', sans-serif",
                            textTransform: "uppercase",
                            backgroundColor: "#1D6ADE",
                            color: "#fff",
                            transition: "all 0.3s ease",

                            "&:hover": {
                                backgroundColor: "#1557B8",
                                transform: "translateY(-2px)",
                                boxShadow: "0 6px 20px rgba(29, 106, 222, 0.3)",
                            },

                        }}
                    >
                        {values.cancelled ? (
                            <>Undo</>
                        ) : values.bookingId ? (
                            t("common.updateBtn")
                        ) : (
                            t("common.saveBtn1")
                        )}
                    </LoadingButton>
                </Box>



                {/*<ButtonGroup
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "center",
          }}
          disableElevation
          variant="contained"
          color={"warning"}
        >
          <Button
            type="submit"
            variant="contained"
            size="medium"
            onClick={() => {
              setGlobalState({
                ...globalState,
                booking: undefined,
                addEditBooking: false,
              });
            }}
            sx={{}}
          >
            {t("common.closeBtn")}
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            size="medium"
            disabled={isDisableSave()}
            onClick={handleSaveBooking}
            sx={{
              ml: 0.5,
              mr: 0.5,
            }}
            loading={isBLoading}
          >
            {values.cancelled ? (
              <>Undo</>
            ) : values.bookingId ? (
              t("common.updateBtn")
            ) : (
              t("common.saveBtn")
            )}
          </LoadingButton>
        </ButtonGroup>*/}
            </Box>
        </FormControl>
    );
};

export default AddBooking;
